export default function parseGherkinExampleTables(examples) {
    return (examples || [])
        .reduce((acc, example) => {

            const keys = example.tableHeader.cells
                .reduce((acc, cell) => ([...acc, cell.value]), []);

            return [
                ...acc,
                ...example.tableBody
                    .reduce((acc, row) => ([
                        ...acc,
                        keys.reduce((acc, key, i) => ([
                            ...acc,
                            {
                                key,
                                value: row.cells[i].value
                            }
                        ]), [])
                    ]), [])
            ];
        }, []);
}
